
import { Options, Vue } from "vue-class-component";
import { PageHeader, PcPageMain } from "./components";
@Options({
  components: {
    PageHeader,
    PcPageMain,
  },
})
export default class SystemHome extends Vue {
  created(): void {}
}
